import { useTranslate } from '@festina-life/ui/hooks'

import { useVariantAction } from '../../../hooks/useVariantAction'
import { useHook } from '../../../lenteHooks'
import { CommandModalButton } from '../../commandActions/CommandModalButton'
import type { CommitmentActionButtonProps } from '../../commandActions/types'
import { AddBalancePostingsForm } from './AddBalancePostingsForm'

export function AddBalancePostingsCommand(props: CommitmentActionButtonProps) {
  const translate = useTranslate()

  const { tenantId, ownerId } = useHook('routing.general.useEntityParams')()

  const actions = useHook('mutators.life.useAddBalancePostingsAction')({
    tenantId,
    ownerId,
    ...props,
  })

  const submit = useVariantAction({ ...props, actions })

  return (
    <CommandModalButton
      actionId="life.AddBalancePostingsCommandData"
      title={translate('action.addBalancePosting.title')}
      commandDataForm={AddBalancePostingsForm}
      {...props}
      submit={submit}
    />
  )
}
